/**
 * PickupCard displays a hotel pickup card with image and hotel name.
 * Handles responsive image rendering for desktop and mobile.
 */
import Image from "next/image";
import Link from "next/link";
import { IPickup } from "./PickupSection";
import { localCloudflareLoader } from "@/lib/utils";

interface PickupCardProps {
  item: IPickup;
  locale: string;
}

export const PickupCard = ({ item, locale }: PickupCardProps) => {
  return (
    <Link
      href={`${locale}/${item.slug}`}
      target="_blank"
      key={item.id}
      className="flex h-full flex-col items-stretch overflow-hidden rounded-lg bg-white"
    >
      <div className="relative h-[152px] w-full md:h-[230px]">
        <Image
          src={
            item.picked_images_desktop?.[0]?.cloudflare_url ||
            item.picked_images_mobile?.[0]?.cloudflare_url ||
            ""
          }
          alt={item?.picked_images_desktop?.[0]?.alternativeText || ""}
          aria-label={item?.picked_images_desktop?.[0]?.caption || ""}
          fill
          loading="lazy"
          className="hidden h-full w-full object-cover md:block"
          sizes="400px"
          loader={localCloudflareLoader(420)}
        />
        <Image
          src={
            item.picked_images_desktop?.[0]?.cloudflare_url ||
            item.picked_images_mobile?.[0]?.cloudflare_url ||
            ""
          }
          alt={item?.picked_images_desktop?.[0]?.alternativeText || ""}
          aria-label={item?.picked_images_desktop?.[0]?.caption || ""}
          fill
          loading="lazy"
          className="block h-full w-full object-cover md:hidden"
          sizes="(max-width: 768px) 100vw, 400px"
          loader={localCloudflareLoader(420)}
        />
      </div>
      <div className="min-h-[60px] flex-1 p-[10px] md:p-7">
        <p className="line-clamp-2 text-center text-xs leading-5 text-[var(--text-gray-stronger)] md:h-[40px] md:text-[19px] md:text-[var(--text-base-primary)]">
          {item.hotel}
        </p>
      </div>
    </Link>
  );
};
